import React from 'react';
import { BucketKind } from '../../../utils/apollo/graphqlSchema';
import * as BuilderInfoUI from '../BuilderInfoUI';
import { InfoPopupHeader } from '../components';
import { IBasicBinning } from '../../../redux/slices/oldBuilder/binning/types';
import {
  EnumBucketDefRows,
  RangeBucketDefRows,
} from '../BucketDefCommon/BucketDefCommon';
import { UnreachableCaseError } from 'ts-essentials';

const BucketDefRows = ({ bucketDef }: { bucketDef: IBasicBinning }) => {
  if (bucketDef.kind === BucketKind.Range) {
    return <RangeBucketDefRows rangeBuckets={bucketDef.customBuckets} />;
  } else if (bucketDef.kind === BucketKind.Enum) {
    return <EnumBucketDefRows enumBuckets={bucketDef.customBuckets} />;
  } else if (bucketDef.kind === BucketKind.Date) {
    return null;
  }

  throw new UnreachableCaseError(bucketDef);
};

export default ({ basicBucketDef }: { basicBucketDef: IBasicBinning }) => {
  const title =
    basicBucketDef.kind === BucketKind.Enum ? 'Bins' : 'Manual Binning';

  return (
    <>
      <InfoPopupHeader name={'Custom'} />
      <BuilderInfoUI.MainContent>
        <BuilderInfoUI.HighlightedLabel>{title}</BuilderInfoUI.HighlightedLabel>
        <BucketDefRows bucketDef={basicBucketDef} />
      </BuilderInfoUI.MainContent>
      {basicBucketDef.kind === BucketKind.Enum &&
        !basicBucketDef.enumBucketSplitOthers && (
          <BuilderInfoUI.Content>
            <BuilderInfoUI.PlainInfo>
              <BuilderInfoUI.InfoLabel>Group Others</BuilderInfoUI.InfoLabel>
              <BuilderInfoUI.BorderedInfo>True</BuilderInfoUI.BorderedInfo>
            </BuilderInfoUI.PlainInfo>
          </BuilderInfoUI.Content>
        )}
    </>
  );
};
